import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Block } from '@definitions/common.types';
import { ContentBody } from '@components/contentBody';
import { PointTitle } from '@components/PDP/pdp.styles';

import { Container } from './artworkShow.styles';

export interface ArtworkShowProps {
  shows: Block[];
}

export const ArtworkShow = ({ shows }: ArtworkShowProps) => (
  <Container>
    <PointTitle>
      <FormattedMessage id="artworkShow.pointTitle" defaultMessage="④ Additional:" />
    </PointTitle>
    <ContentBody body={shows} />
  </Container>
);
